import { render, staticRenderFns } from "./Librerialibros.vue?vue&type=template&id=aeefc8c8&scoped=true&"
import script from "./Librerialibros.vue?vue&type=script&lang=js&"
export * from "./Librerialibros.vue?vue&type=script&lang=js&"
import style0 from "./Librerialibros.vue?vue&type=style&index=0&id=aeefc8c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefc8c8",
  null
  
)

export default component.exports